import { connect } from 'react-redux';
import moment from 'moment';
import _sortBy from 'lodash/sortBy';

import { updateProgram } from '@store/actions/programs';
import { requestProgramDetailsSimple } from '@tvguide/store/actions/requests';
import { setUXProp } from '@store/actions/ux';
import TextView from './textview';

const mapStateToProps = state => {
  const selectedChannel = state.channels.find(
    c => c.service_id === state.ux.selectedChannel,
  );
  const now = moment();
  let programs = [];

  const isActiveDayToday = moment(state.ux.activeDay).isSame(moment(), 'day');

  if (selectedChannel && selectedChannel.programs) {
    programs = selectedChannel.programs.filter(p => {
      if (isActiveDayToday) {
        return (
          moment(p.start_time)
            .add(moment.duration(p.duration))
            .isAfter(now) && p.start_time
        );
      }

      return (
        moment(p.start_time).isSame(state.ux.activeDay, 'day') && p.start_time
      );
    });
  }

  return {
    channels: _sortBy(state.channels, ['logical_channel_number']),
    selectedChannel: selectedChannel || null,
    programs: programs,
    isActiveDayToday: isActiveDayToday,
    accessibility: state.ux.accessibilities,
  };
};

const mapDispatchToProps = dispatch => ({
  setSelectedChannel: channelId => {
    dispatch({ type: 'CANCEL_REQUESTS' });
    dispatch(setUXProp({ selectedChannel: channelId }));
  },
  getProgramsDetails: programs => {
    new Promise(resolve => {
      programs.forEach(p => {
        dispatch(updateProgram(p.sid, p.id, { requesting: true }));
      });
      resolve();
    })
      .then(() => {
        programs.forEach(p => {
          dispatch(requestProgramDetailsSimple(p.id, p.sid, p.pid));
        });
      })
      .catch(error => {
        console.error(error);
      });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TextView);
